// Mini Info/Definition dialog

$(document).ready(function(){
  // open the info box
  $(".ts-info-dialog").on("click", function(event){
    if(event.target.id){
      let info = document.querySelector("#"+event.target.id).dataset;
      setupTSInfo(info);
    }
  }); 
  // close box when ESC key is used
  $(document).keyup(function(event){
    if(event.key == "Escape" || event.key == "Esc"){
      closeInfoBox();
    }
  });
});


/**
 * Setup the TS modal from either JS or CF
 * @param {Object} dataTags - in the form of { title: 'Break', info: 'and so on....', id: 'id-goes-here' }
 */
function setupTSInfo(dataTags){
  let infoBoxHTML = `<div id="`+dataTags.id+`-info" class="info-content">`;
  if(dataTags.title){
    infoBoxHTML += `<div class="infoTitle">${dataTags.title}</div>`;
  }
  infoBoxHTML += `<div>${dataTags.info}</div>`;
  infoBoxHTML += `<div class="infoClose">` + getTranslation("Content.Btn.Close") + `</div>`;
  infoBoxHTML += `</div>`;
  $("#"+dataTags.id).append(infoBoxHTML);

  // position the info box above the link to it 
  let topPosition = ($("#"+dataTags.id).position().top) - 100;
  let leftPosition = $("#"+dataTags.id).position().left;
  if(screen.width < 576) {  // = $phoneBreakpoint in scss
    topPosition = topPosition - 50;
    leftPosition = 50;
  }
  $(".info-content").css({ top: topPosition, left: leftPosition, position: "absolute" });

  // event listener to close the info box when we click anywhere outside the box or the link to it 
  document.addEventListener("click", (event) => {
    // close the info box if the X is clicked or anywhere other than the referring link 
    if(event.target.className == "infoClose" || event.target.className != "ts-info-dialog"){
      closeInfoBox();
    }
   });
}

function closeInfoBox() {
  $(".info-content").hide();
}

/*
// ******* Setup in CF file *******

// must have class="ts-info-dialog"

<div class="ts-info-dialog" data-id="your_id_here" id="your_id_here" data-title="Optional Title Here" data-info="Info text here">
  Text, icon, logic etc will go here 
</div>  

*/
